import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=2da6d2b8"
import script from "./ItemCard.vue?vue&type=script&lang=js"
export * from "./ItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports